import * as z from "zod";

export const teamHasRmaIntegration = {
  name: "teamHasRmaIntegration" as const,
  input: z.null(),
  output: z.object({ hasRmaIntegration: z.boolean() }),
};
